import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import classNames from "classnames";
import { Button } from "@jti/ui";
import styles from "../SingleError.module.scss";
export const CheckoutErrorMessage = ({ onRemoveItems, items, className, variant = "regular", title, intro, buttonText, }) => {
    const hasStringId = (item) => {
        return typeof item.id === "string";
    };
    const handleOnRemove = useCallback(() => {
        if (onRemoveItems) {
            const stringItemIds = items.filter(hasStringId).map((item) => item.id);
            onRemoveItems(stringItemIds);
        }
    }, [items, onRemoveItems]);
    if (items.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx("p", { className: classNames(styles.title, { [styles.titleRegular]: variant === "regular" }, className), children: title }), variant === "regular" ? (_jsxs(_Fragment, { children: [intro && _jsx("p", { className: styles.intro, children: intro }), buttonText && (_jsx(Button, { type: "button", variant: "cta", onClick: handleOnRemove, children: buttonText }))] })) : null] }));
};
//# sourceMappingURL=CheckoutErrorMessage.js.map